import { useEffect, useState } from 'react';
import { settingsApi } from '@/lib/api/arrex/settings';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { FormSkeleton } from '@/components/ui/skeletons';

export default function AdminSettings() {
  const { t } = useTranslation();
  const [settings, setSettings] = useState<any | null>(null);

  useEffect(() => {
    settingsApi.adminGet().then(({ settings }) => setSettings(settings || {})).catch(() => setSettings({}));
  }, []);

  const save = async () => {
    try {
      await settingsApi.update({
        store_name: settings.store_name,
        whatsapp_url: settings.whatsapp_url,
        facebook_url: settings.facebook_url,
        instagram_url: settings.instagram_url,
        tiktok_url: settings.tiktok_url,
      });
      toast.success('Saved');
    } catch (e: any) {
      toast.error(e?.message || 'Failed to save');
    }
  };

  if (!settings) return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl font-bold">{t('admin.nav.settings')}</h1>
      <FormSkeleton rows={5} />
    </div>
  );

  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl font-bold">{t('admin.nav.settings')} — {t('admin.settingsPage.general')}</h1>

      <section className="surface-card rounded-lg p-6 grid md:grid-cols-2 gap-4 max-w-3xl">
        <h2 className="md:col-span-2 font-display text-lg">{t('admin.settingsPage.store')}</h2>
        <div className="md:col-span-2">
          <Label>{t('admin.settingsPage.storeName')}</Label>
          <Input value={settings.store_name || ''} onChange={e => setSettings({ ...settings, store_name: e.target.value })} placeholder="e.g. SEEN Store" />
        </div>
        {(['whatsapp_url', 'facebook_url', 'instagram_url', 'tiktok_url'] as const).map(k => (
          <div key={k}>
            <Label className="capitalize">{k.replace('_url', '')}</Label>
            <Input value={settings[k] || ''} onChange={e => setSettings({ ...settings, [k]: e.target.value })} placeholder="https://..." />
          </div>
        ))}
        <div className="md:col-span-2"><Button onClick={save}>{t('admin.save')}</Button></div>
      </section>
    </div>
  );
}
